import {
  BookOpenCheck,
  History,
  Newspaper,
  PanelRightOpen,
  Plus,
} from "lucide-react";

export function ChatCanvasActionStrip({
  onNewChat,
  onOpenHistory,
  onDailySummary,
  onOpenWorkbench,
  onOpenEvidence,
}: {
  onNewChat: () => void;
  onOpenHistory: () => void;
  onDailySummary: () => void;
  onOpenWorkbench?: () => void;
  onOpenEvidence?: () => void;
}) {
  return (
    <div className="chat-canvas-action-strip pointer-events-auto absolute right-4 top-1 z-20 flex items-center gap-3">
      <button
        type="button"
        className="chat-canvas-action-button"
        aria-label="New conversation"
        title="New conversation"
        onClick={onNewChat}
      >
        <Plus size={16} strokeWidth={1.8} />
      </button>
      <button
        type="button"
        className="chat-canvas-action-button"
        aria-label="Conversation history"
        title="Conversation history"
        onClick={onOpenHistory}
      >
        <History size={16} strokeWidth={1.8} />
      </button>
      <button
        type="button"
        className="chat-canvas-action-button"
        aria-label="Daily summary"
        title="Daily summary"
        onClick={onDailySummary}
      >
        <Newspaper size={16} strokeWidth={1.8} />
      </button>
      {onOpenWorkbench ? (
        <button
          type="button"
          className="chat-canvas-action-button"
          aria-label="Open workbench"
          title="Open workbench"
          onClick={onOpenWorkbench}
        >
          <PanelRightOpen size={16} strokeWidth={1.8} />
        </button>
      ) : null}
      {onOpenEvidence ? (
        <button
          type="button"
          className="chat-canvas-action-button"
          aria-label="Open evidence"
          title="Open evidence"
          onClick={onOpenEvidence}
        >
          <BookOpenCheck size={16} strokeWidth={1.8} />
        </button>
      ) : null}
    </div>
  );
}
